export const authSilceName = "auth";

export const authInitState = {
  authenticated: false,
  accessToken: null,
  userInfo: {
    name: null,
    phone: null,
    changePasswordRequired: false,
    subsidiaryUuids: [],
    userTypes: [],
  },
};
